module.exports = __webpack_public_path__ + "img/katan_no.9215189c.png";